function n(t, u) {
  let e;
  return (...i) => {
    e !== void 0 && clearTimeout(e), e = setTimeout(() => t(...i), u);
  };
}
export {
  n as debounce
};
